<template>
  <ReportViewPage
    :key="reporttype"
    :source="companyId"
    :type="reporttype"
    :path="path"
  />
</template>

<script>

import ReportViewPage from '@telexpress_auth/vue-report/dist/components/reportView.umd.min';
import store from '@/store';

export default {
  components: {
    ReportViewPage
  },
  props: {
    reporttype: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      companyId: '',
      path: ''
    };
  },
  created() {
    const { company } = store.getters;
    this.companyId = company;
  }
};
</script>
